document.addEventListener("DOMContentLoaded", () => {
  initAccordion();
});

function initAccordion() {
  const titles = document.querySelectorAll(".accordion_title");

  titles.forEach((title) => {
    title.addEventListener("click", () => {
      const content = title.nextElementSibling;
      if (!content || !content.classList.contains("accordion_content")) return;

      const isOpen = title.classList.toggle("active");
      content.classList.toggle("show", isOpen);

      if (isOpen) {
        openAccordion(content);
      } else {
        closeAccordion(content);
      }
    });
  });
}

function measureHeight(content) {
  const inner = content.querySelector(".accordion_inner");

  // 視覚上の高さを小数まで取って切り上げ + 1px保険（border-bottomの欠け対策）
  if (inner) return Math.ceil(inner.getBoundingClientRect().height) + 1;

  return Math.ceil(content.scrollHeight) + 1;
}

function openAccordion(content) {
  // いったん 0 → 実測値にして transition を確実に効かせる
  content.style.height = "0px";

  requestAnimationFrame(() => {
    const h = measureHeight(content);
    content.style.height = h + "px";
  });

  // 開き切ったら auto にして内容が増減しても崩れないようにする
  const onEnd = (e) => {
    if (e.propertyName !== "height") return;
    content.style.height = "auto";
    content.removeEventListener("transitionend", onEnd);
  };
  content.addEventListener("transitionend", onEnd);
}

function closeAccordion(content) {
  // auto のままだと 0 にアニメーションできないので、現在高を px に固定してから閉じる
  const h = Math.ceil(content.getBoundingClientRect().height);
  content.style.height = h + "px";

  requestAnimationFrame(() => {
    content.style.height = "0px";
  });
}